var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card_container"},[_c('h1',{staticClass:"lung_counter"},[_vm._v(_vm._s(_vm.totalLungsObservedCount))]),_c('p',{staticClass:"subtext"},[_vm._v("Total Lungs Examined")])])}
var staticRenderFns = []

export { render, staticRenderFns }